import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-704d0b86"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "evaluatable-label"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-code" }, null, -1 /* HOISTED */));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 2,
    class: "form"
};
const _hoisted_6 = { class: "evaluatable-prefix-wrapper" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "@", -1 /* HOISTED */));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, ":", -1 /* HOISTED */));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-code" }, null, -1 /* HOISTED */));
const _hoisted_10 = [
    _hoisted_9
];
import { ElDropdown, ElDropdownItem, ElDropdownMenu, } from "element-plus";
import { evaluatableLanguageOptions, evaluatablePhaseOptions, useDestructuredEvaluatableValue, } from ".";
import { computed, ref, watch, onBeforeUnmount, nextTick, unref } from "vue";
import { useFocus } from "@vueuse/core";
import { adjustTextareaHeight } from "src/shared/v-components/campaign-component-variable/input/input-service";
import TextareaAutosize from "../v-components/ui/form/TextareaAutosize.vue";
import { useDeveloperMode } from "../store/me/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EvaluatableInputWrapper',
    props: {
        modelValue: {},
        defaultProvidedValue: {},
        isFocused: { type: Boolean, default: false },
        autosize: { type: Boolean, default: false },
        label: {}
    },
    emits: ["update:modelValue", "update:isFocused"],
    setup(__props, { emit: __emit }) {
        const { developerMode } = useDeveloperMode();
        const props = __props;
        const emit = __emit;
        const textarea = ref(undefined);
        const languagedropdown = ref();
        const phasedropdown = ref();
        const focusLock = ref(false);
        const languagelink = ref(null);
        const phaselink = ref(null);
        const hoverIconElement = ref(null);
        const onLanguageClicked = () => {
            if (languagedropdown.value) {
                focusLock.value = true;
                languagedropdown.value.handleOpen();
            }
        };
        const onPhaseClicked = () => {
            if (phasedropdown.value) {
                focusLock.value = true;
                phasedropdown.value.handleOpen();
            }
        };
        const onControlsDropdownVisibilityChange = (isVisible) => {
            const hasBeenClosed = !isVisible;
            if (hasBeenClosed) {
                focusLock.value = false;
                focused.value = true;
            }
        };
        const hasUserClickedOnControlsLink = (target) => {
            return languagelink.value === target || phaselink.value === target;
        };
        const onBlur = (event) => {
            if (hasUserClickedOnControlsLink(event.relatedTarget)) {
                return;
            }
            else {
                emit("update:isFocused", false);
            }
        };
        const { focused } = useFocus(textarea, {
            initialValue: props.isFocused,
        });
        watch(focusLock, (value) => {
            if (value) {
                emit("update:isFocused", true);
            }
            else {
                focused.value = true;
            }
        });
        watch(focused, (value) => {
            if (value === true) {
                emit("update:isFocused", true);
                adjustTextareaHeight(textarea, focused);
            }
        });
        watch(() => props.isFocused, (value) => {
            focused.value = value;
        });
        const valueProxy = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        const { value, language, phase, isProvided, makeEvaluatable, makeProvided, setPhase, setLanguage, } = useDestructuredEvaluatableValue(valueProxy);
        const isHoveringWrapper = ref(false);
        const isHoveringIcon = ref(false);
        const showHoverIcon = ref(false);
        let showTimeout = null;
        let hideTimeout = null;
        const tryShowIcon = () => {
            if (props.label)
                return;
            if (hideTimeout)
                clearTimeout(hideTimeout);
            hideTimeout = null;
            if (showTimeout)
                clearTimeout(showTimeout);
            showTimeout = setTimeout(() => {
                if (isHoveringWrapper.value) {
                    showHoverIcon.value = true;
                }
            }, 1000);
        };
        const tryHideIcon = () => {
            if (props.label)
                return;
            if (hideTimeout)
                clearTimeout(hideTimeout);
            hideTimeout = setTimeout(() => {
                if (!isHoveringWrapper.value && !isHoveringIcon.value) {
                    if (showTimeout)
                        clearTimeout(showTimeout);
                    showTimeout = null;
                    showHoverIcon.value = false;
                }
                hideTimeout = null;
            }, 500);
        };
        const handleWrapperMouseEnter = () => {
            isHoveringWrapper.value = true;
            tryShowIcon();
        };
        const handleWrapperMouseLeave = () => {
            isHoveringWrapper.value = false;
            tryHideIcon();
        };
        const handleIconMouseEnter = () => {
            focusLock.value = true;
            isHoveringIcon.value = true;
            if (hideTimeout)
                clearTimeout(hideTimeout);
            hideTimeout = null;
        };
        const handleIconMouseLeave = () => {
            focusLock.value = false;
            isHoveringIcon.value = false;
            tryHideIcon();
        };
        onBeforeUnmount(() => {
            emit("update:isFocused", false);
            if (showTimeout)
                clearTimeout(showTimeout);
            if (hideTimeout)
                clearTimeout(hideTimeout);
        });
        watch(isProvided, (value) => {
            if (!value) {
                nextTick(() => {
                    focused.value = true;
                });
            }
        });
        const previousProvidedValue = ref();
        const previousEvaluatableValue = ref();
        const toggleEvaluatableness = () => {
            if (isProvided.value) {
                previousProvidedValue.value = {
                    value: unref(value),
                };
                if (previousEvaluatableValue.value !== undefined) {
                    makeEvaluatable(previousEvaluatableValue.value.language, previousEvaluatableValue.value.phase);
                }
                else {
                    makeEvaluatable("javascript", "buildtime");
                }
            }
            else {
                if (language.value !== null && phase.value !== null) {
                    previousEvaluatableValue.value = {
                        language: language.value,
                        phase: phase.value,
                        value: value.value,
                    };
                }
                if (previousProvidedValue.value !== undefined) {
                    makeProvided(previousProvidedValue.value.value);
                }
                else {
                    makeProvided(props.defaultProvidedValue);
                }
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["evaluatable-input-wrapper", { 'has-prefix': !_unref(isProvided) && typeof _unref(value) === 'string' }]),
                onMouseenter: handleWrapperMouseEnter,
                onMouseleave: handleWrapperMouseLeave
            }, [
                (_ctx.label)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1 /* TEXT */),
                        _createElementVNode("div", {
                            onClick: _withModifiers(toggleEvaluatableness, ["stop"]),
                            class: _normalizeClass(["icon-button", {
                                    'icon-button--selected': !_unref(isProvided),
                                }])
                        }, _hoisted_3, 2 /* CLASS */)
                    ]))
                    : _createCommentVNode("v-if", true),
                (_unref(isProvided))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "default")
                    ]))
                    : (typeof _unref(value) === 'string')
                        ? (_openBlock(), _createElementBlock("form", _hoisted_5, [
                            _withDirectives(_createElementVNode("span", _hoisted_6, [
                                _createVNode(_unref(ElDropdown), {
                                    ref_key: "languagedropdown",
                                    ref: languagedropdown,
                                    trigger: "contextmenu",
                                    onCommand: _unref(setLanguage),
                                    onVisibleChange: onControlsDropdownVisibilityChange
                                }, {
                                    dropdown: _withCtx(() => [
                                        _createVNode(_unref(ElDropdownMenu), null, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evaluatableLanguageOptions), (option) => {
                                                    return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                                        key: option.value,
                                                        command: option.value
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(option.displayName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["command"]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("span", {
                                            ref_key: "languagelink",
                                            ref: languagelink,
                                            class: "el-dropdown-link",
                                            tabindex: "0",
                                            onClick: onLanguageClicked
                                        }, _toDisplayString(_unref(language)), 513 /* TEXT, NEED_PATCH */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onCommand"]),
                                _hoisted_7,
                                _createVNode(_unref(ElDropdown), {
                                    ref_key: "phasedropdown",
                                    ref: phasedropdown,
                                    trigger: "contextmenu",
                                    onCommand: _unref(setPhase),
                                    onVisibleChange: onControlsDropdownVisibilityChange
                                }, {
                                    dropdown: _withCtx(() => [
                                        _createVNode(_unref(ElDropdownMenu), null, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evaluatablePhaseOptions), (option) => {
                                                    return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                                        key: option.value,
                                                        command: option.value
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(option.displayName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["command"]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("span", {
                                            class: "el-dropdown-link",
                                            ref_key: "phaselink",
                                            ref: phaselink,
                                            tabindex: "0",
                                            onClick: onPhaseClicked
                                        }, _toDisplayString(_unref(phase)), 513 /* TEXT, NEED_PATCH */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onCommand"]),
                                _hoisted_8
                            ], 512 /* NEED_PATCH */), [
                                [_vShow, _unref(developerMode)]
                            ]),
                            (_ctx.autosize)
                                ? (_openBlock(), _createBlock(TextareaAutosize, {
                                    key: 0,
                                    modelValue: _unref(value),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(value) ? (value).value = $event : null)),
                                    onBlur: onBlur
                                }, null, 8 /* PROPS */, ["modelValue"]))
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    class: _normalizeClass({ code: _unref(language) !== 'handlebars' }),
                                    onBlur: onBlur,
                                    ref_key: "textarea",
                                    ref: textarea,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(value) ? (value).value = $event : null))
                                }, null, 34 /* CLASS, NEED_HYDRATION */)), [
                                    [_vModelText, _unref(value)]
                                ])
                        ]))
                        : _createCommentVNode("v-if", true),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (!_ctx.label && showHoverIcon.value && _unref(developerMode))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                ref_key: "hoverIconElement",
                                ref: hoverIconElement,
                                onClick: _withModifiers(toggleEvaluatableness, ["stop"]),
                                onMouseenter: handleIconMouseEnter,
                                onMouseleave: handleIconMouseLeave,
                                class: _normalizeClass(["icon-button hover-toggle-icon", {
                                        'icon-button--selected': !_unref(isProvided),
                                    }])
                            }, _hoisted_10, 34 /* CLASS, NEED_HYDRATION */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ], 34 /* CLASS, NEED_HYDRATION */));
        };
    }
});
